export default __webpack_public_path__ + "static/media/hristina_xl.b14ba62c.jpg";